export type SignatureOptionsSwissVisibility = {
    hasSignature: true;
    isCollectiveSignature: true;
    placeSignatureAfterAop: true;
};
